export default "__VITE_ASSET__edfab977__$_?component__"